import { app, h } from '@pdf-tools/four-heights-pdf-web-viewer/es6/lib/hyperapp';
import { PdfItemType } from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-api';
import { translationManager } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/TranslationManager';
import { Toolbar } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/Toolbar';
import { ToolbarItemGroup } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/ToolbarItemGroup';
import { ToolbarButton } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/ToolbarButton';
import { icons } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/icons';
import { ToolbarSeparator } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/ToolbarSeparator';
import { StrokeWidthPicker } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/StrokeWidthPicker';
import { StrokeStylePicker } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/StrokeStylePicker';
import { ColorPicker } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/ColorPicker';
export const createCustomAddShapeAnnotationToolbar = (props: any, element: any) => {
  const state = {
    strokeColors: props.strokeColors,
    strokeWidths: props.strokeWidths,
    fillColors: props.fillColors,
    selectedShape: props.selectedShape,
    selectedStrokeColor: props.selectedStrokeColor,
    selectedStrokeWidth: props.selectedStrokeWidth,
    selectedStrokeStyle: props.selectedStrokeStyle,
    selectedFillColor: props.selectedFillColor,
  };
  const iconLine = {
    width: 300,
    height: 300,
    path: 'M 16,0 300,284 284,300 0,16 16,0',
  };

  const actions = {
    setShape: (shape: any) => ($state: any) => {
      props.onShapeChanged(shape);
      return Object.assign(Object.assign({}, $state), { selectedShape: shape });
    },
    setStrokeColor: (color: any) => ($state: any) => {
      props.onStrokeColorChanged(color);
      return Object.assign(Object.assign({}, $state), { selectedStrokeColor: color });
    },
    setStrokeWidth: (width: any) => ($state: any) => {
      props.onStrokeWidthChanged(width);
      return Object.assign(Object.assign({}, $state), { selectedStrokeWidth: width });
    },
    setStrokeStyle: (style: any) => ($state: any) => {
      props.onStrokeStyleChanged(style);
      return Object.assign(Object.assign({}, $state), { selectedStrokeStyle: style });
    },
    setFillColor: (color: any) => ($state: any) => {
      props.onFillColorChanged(color);
      return Object.assign(Object.assign({}, $state), { selectedFillColor: color });
    },
    setCancel: () => ($state: any) => {
      return Object.assign({}, $state);
    },
  };


  // @ts-ignore
  const App = () => h(AddCustomShapeAnnotationToolbar, null);
  // eslint-disable-next-line no-empty-pattern
  const AddCustomShapeAnnotationToolbar = ({}) => ($state:any, $actions:any) => {
    function getShapeType(selectedShapeType: number) {
      const shapetypes: {[key: number]: 'line' | 'rectangle' | 'circle'} =  {
        [PdfItemType.SQUARE]: 'rectangle',
        [PdfItemType.CIRCLE]: 'circle',
        [PdfItemType.LINE]: 'line'
      }

      return shapetypes[selectedShapeType];
    }
    // @ts-ignore
    const shapeGroup = h(ToolbarItemGroup, null,
      h(ToolbarButton, { tooltip: translationManager.getText('annotShape.addRectangle'),
        icon: iconLine,  active: $state.selectedShape === PdfItemType.LINE, onClick: () => {
          $actions.setShape(PdfItemType.LINE);
        } }),
      h(ToolbarButton, { tooltip: translationManager.getText('annotShape.addRectangle'),
        icon: icons.rectangle, active: $state.selectedShape === PdfItemType.SQUARE, onClick: () => {
          $actions.setShape(PdfItemType.SQUARE);
        } }),
      h(ToolbarButton, { tooltip: translationManager.getText('annotShape.addEllipse'),
        icon: icons.circle, active: $state.selectedShape === PdfItemType.CIRCLE, onClick: () => {
          $actions.setShape(PdfItemType.CIRCLE);
        } }));



    // @ts-ignore
    const strokeGroup = h(ToolbarItemGroup, null,
      h(StrokeWidthPicker, {
        tooltip: translationManager.getText('annotShape.strokeWidth'),
        noneStrokeText: '', strokeWidths: $state.strokeWidths.filter((width: number) => width !== 0),
        value: $state.selectedStrokeWidth, onChange: $actions.setStrokeWidth
      }),

      h(StrokeStylePicker, {
        tooltip: translationManager.getText('annotShape.strokeStyle'),
        value: $state.selectedStrokeStyle, disabled: $state.selectedStrokeWidth === 0,
        onChange: $actions.setStrokeStyle,
        shapeType: getShapeType($state.selectedShape)
      }),

      h(ColorPicker, {
        tooltip: translationManager.getText('annotShape.strokeColor'),
        colors: $state.strokeColors, color: $state.selectedStrokeColor,
        disabled: $state.selectedStrokeWidth === 0, icon: icons.pencil, onChange: $actions.setStrokeColor
      }));

    // @ts-ignore
    const colorGroup = h(ToolbarItemGroup, null,
      // @ts-ignore
      h(ToolbarSeparator, null),
      h(ColorPicker, {
        tooltip: translationManager.getText('annotShape.bgColor'),
        disabled: $state.selectedShape === PdfItemType.LINE,
        colors: $state.fillColors, color: $state.selectedFillColor,
        icon: icons.fillColor, onChange: $actions.setFillColor
      }));

    const closeButtonGroup = h(ToolbarItemGroup, { pushRight: true },
      // @ts-ignore
      h(ToolbarSeparator, null),
      h(ToolbarButton, { icon: icons.close, onClick: props.onCancel }));

    if ($state.itemType === PdfItemType.LINE) {
      return (h(Toolbar, { allowWrap: true, alignCenter: true },
        // @ts-ignore
        shapeGroup, strokeGroup,  closeButtonGroup));
    }
    // toolbar
    return (h(Toolbar, { allowWrap: true, alignCenter: true },
      // @ts-ignore
      shapeGroup, strokeGroup, colorGroup, closeButtonGroup));
  }

  return app(state, actions, App, element);
};
